document.addEventListener('alpine:init', () => {
    Alpine.data('tabbedPostGrid', () => ({
        activeTab: 1,
    }))
}); 